export default __webpack_public_path__ + "static/media/icon-best-seller.bc0e08c5.svg";